import * as yup from "yup";

import { validationSchema } from "components/MultiFactorAuthorization/components/sms/steps/VerifyCode/validationSchema";

export const mfaSignInValidationSchema = validationSchema;

export type MfaSignInFormType = yup.InferType<typeof mfaSignInValidationSchema>;
